import React from 'react';
import { TableRow, TableCell, TableSelectRow } from 'carbon-components-react';

const DisplayEmailRow: React.FC<any> = ({
  row,
  getRowProps,
  getSelectionProps
}: any) => {
  return (
    <TableRow {...getRowProps({ row })}>
      <TableSelectRow {...getSelectionProps({ row })} />
      <TableCell key={'sent'}>{row.cells[0].value}</TableCell>
      <TableCell key={'subject'}>{row.cells[3].value}</TableCell>
      <TableCell key={'attachment'}>{row.cells[4].value}</TableCell>
      <TableCell key={'status'}>{row.cells[5].value}</TableCell>
    </TableRow>
  );
};
DisplayEmailRow.displayName = 'DisplayEmailRow';
export default DisplayEmailRow;
